import { __awaiter, __decorate, __metadata } from "tslib";
import { inject, injectable, postConstruct } from 'mana-syringe';
import { ICommandHandler, ICommandContextProvider } from '../../command/interface';
import { XFlowNodeCommands } from '../constant';
import { Disposable } from '../../common/disposable';
export var NsFrontNode;
(function (NsFrontNode) {
    NsFrontNode.command = XFlowNodeCommands.FRONT_NODE;
    NsFrontNode.hookKey = 'frontNode';
})(NsFrontNode || (NsFrontNode = {}));
let FrontNodeCommand = 
/** 节点前置命令(始终在画布最前方) */
class FrontNodeCommand {
    constructor() {
        this.execute = () => __awaiter(this, void 0, void 0, function* () {
            const ctx = this.contextProvider();
            const { args, hooks: runtimeHook } = ctx.getArgs();
            const hooks = ctx.getHooks();
            const result = yield hooks.frontNode.call(args, (handlerArgs) => __awaiter(this, void 0, void 0, function* () {
                const x6Graph = yield this.ctx.getX6Graph();
                const { nodeId } = handlerArgs;
                const x6Node = x6Graph === null || x6Graph === void 0 ? void 0 : x6Graph.getCellById(nodeId);
                if (!x6Node) {
                    console.error(nodeId, 'this nodeId is not exist');
                }
                else {
                    x6Node.toFront();
                    /** frontNode undo */
                    ctx.addUndo(Disposable.create(() => __awaiter(this, void 0, void 0, function* () {
                        handlerArgs.commandService.executeCommand(XFlowNodeCommands.BACK_NODE.id, {
                            nodeId,
                        });
                    })));
                }
                return {};
            }), runtimeHook);
            ctx.setResult(result);
            return this;
        });
        this.undo = () => __awaiter(this, void 0, void 0, function* () {
            this.ctx.undo();
            return this;
        });
        this.redo = () => __awaiter(this, void 0, void 0, function* () {
            if (!this.ctx.isUndoable) {
                yield this.execute();
            }
            return this;
        });
    }
    init() {
        this.ctx = this.contextProvider();
    }
    isUndoable() {
        return this.ctx.isUndoable();
    }
};
__decorate([
    inject(ICommandContextProvider),
    __metadata("design:type", Object)
], FrontNodeCommand.prototype, "contextProvider", void 0);
__decorate([
    postConstruct(),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], FrontNodeCommand.prototype, "init", null);
FrontNodeCommand = __decorate([
    injectable({
        token: { token: ICommandHandler, named: NsFrontNode.command.id },
    })
    /** 节点前置命令(始终在画布最前方) */
], FrontNodeCommand);
export { FrontNodeCommand };
//# sourceMappingURL=node-front.js.map